import { GptModels } from '../types'

export const CHAT_COMPLETIONS_API_URL =
  'https://api.openai.com/v1/chat/completions'

export const OPEN_AI_MODELS: GptModels[] = [
  GptModels.Gpt_5_4_mini, // WARN: temperature parameter is only supported when using GPT-5.4 with reasoning effort set to none
  GptModels.Gpt_5_4_nano, // WARN: temperature parameter is only supported when using GPT-5.4 with reasoning effort set to none
  GptModels.Gpt_5_4, // WARN: temperature parameter is only supported when using GPT-5.4 with reasoning effort set to none
  GptModels.Gpt_4o,
  GptModels.Gpt_5,
  GptModels.Gpt_4o_mini,
  GptModels.Gpt_4_turbo,
  GptModels.Gpt_o3_mini,
]

// Exam-paper ingestion pipeline. Reached from FileUploadSection, which is rendered by the
// student Interactive Paper page as well as the admin one — a bad parse is student-visible.
// Kept out of OPEN_AI_MODELS on purpose: those routes pick a model directly rather than
// walking the fallback chain.
export const PAPER_INGESTION_MODEL = GptModels.Gpt_5_6_luna

// The Assistants API rejects every gpt-5.6 tier ("cannot be used with the Assistants API"),
// so the PDF-attachment paths stay on gpt-4o. All of them currently sit in routes with no
// callers, so this blocks no live traffic — revisit if they are ever wired up again.
export const PAPER_INGESTION_ASSISTANTS_MODEL = GptModels.Gpt_4o

// Question / mark-scheme extraction: feeds grading for every student who touches the paper,
// so it takes the accuracy-preserving tier rather than the cheapest one.
export const PAPER_EXTRACTION_MODEL = GptModels.Gpt_5_6_terra

export const OPEN_AI_MODELS_NO_JSON_SCHEMA_SUPPORT: GptModels[] = [
  GptModels.Gpt_4_turbo,
]

// WARN: every gpt-5.6 tier rejects `temperature` outright (only the default 1 is accepted).
// Any model added to OPEN_AI_MODELS must be checked against this list, or the streaming
// route will send temperature, get a 400, and silently fall through to the next model.
export const OPEN_AI_MODELS_NO_TEMPERATURE_SUPPORT: GptModels[] = [
  GptModels.Gpt_5,
  GptModels.Gpt_o3_mini,
  GptModels.Gpt_5_6_luna,
  GptModels.Gpt_5_6_terra,
  GptModels.Gpt_5_6_sol,
]

// no image input support models
export const OPEN_AI_MODELS_NO_VISION_SUPPORT: GptModels[] = [
  GptModels.Gpt_o3_mini,
]
